module.exports = __webpack_public_path__ + "410bfeb3b726be81e4a1232aee5681c4.MP3";